export default __webpack_public_path__ + "static/media/capsule-landing-token-capsule-coin.34030e3d.png";